<template>
	<section class="dim-popup-wrap" id="dimPinPassword">
		<section class="dim-popup-mark" @click="close"></section>
		<section class="dim-popup-content">
			<h1>PIN번호 입력</h1>
			<div class="button close" @click="close">닫기</div>
			<div class="contents">
				<div class="circle">
					<input type="checkbox" :checked="pin.length > 0" @click="clickCheckBox" />
					<input type="checkbox" :checked="pin.length > 1" @click="clickCheckBox" />
					<input type="checkbox" :checked="pin.length > 2" @click="clickCheckBox" />
					<input type="checkbox" :checked="pin.length > 3" @click="clickCheckBox" />
					<span v-if="failFlag">비밀번호를 확인해주세요.</span>
				</div>
				<div class="number">
					<button @click="clickBtn(1)">1</button>
					<button @click="clickBtn(2)">2</button>
					<button @click="clickBtn(3)">3</button>
					<button @click="clickBtn(4)">4</button>
					<button @click="clickBtn(5)">5</button>
					<button @click="clickBtn(6)">6</button>
					<button @click="clickBtn(7)">7</button>
					<button @click="clickBtn(8)">8</button>
					<button @click="clickBtn(9)">9</button>
					<button></button>
					<button @click="clickBtn(0)">0</button>
					<button @click="clickDelete">
						<img :src="require('@/assets/img/popup/btn-numeric-delete.png')" alt="" />
					</button>
				</div>
			</div>
		</section>
	</section>
</template>

<script>
import { popOpenAndScrollNone, popCloseAndScrollAuto } from '@/utils/UtilPopup';

export default {
	data() {
		return {
			pin: '',
			failFlag: false
		};
	},
	props: {
		// { parentPage: '', closeFuncName: 'setPinOff', rightFuncName: 'setPinOn' }
		propData: {
			type: Object,
			required: true
		}
	},
	computed: {},
	watch: {},
	methods: {
		save() {},
		// 팝업 열기
		open() {
			popOpenAndScrollNone('#dimPinPassword .dim-popup-mark', '#dimPinPassword .dim-popup-content');
		},
		// 팝업 닫기
		close() {
			if (this.propData.closeFuncName !== null) {
				this.$emit('childFunc', this.propData.closeFuncName, {});
			}

			this.onlyClose();
		},
		// only Close
		onlyClose() {
			popCloseAndScrollAuto('#dimPinPassword .dim-popup-mark', '#dimPinPassword .dim-popup-content');
			this.pin = '';
		},
		// 클릭 할 때 체크 on, off 못하도록
		clickCheckBox(e) {
			e.target.checked = !e.target.checked;
		},
		clickBtn(val) {
			if (this.pin.length >= 4) {
				return;
			}

			switch (val) {
				case 1:
				case 2:
				case 3:
				case 4:
				case 5:
				case 6:
				case 7:
				case 8:
				case 9:
				case 0:
					this.pin = this.pin + val;
					this.failFlag = false;
					break;
			}

			if (this.pin.length === 4) {
				if (this.propData.parentPage === 'checkupLayout') {
					if (this.pin === this.$store.state.settingInfo.questionPw) {
						this.$emit('childFunc', this.propData.rightFuncName, {});
						this.onlyClose();
					} else {
						this.failFlag = true;
						this.pin = '';
					}
				} else {
					this.$emit('childFunc', this.propData.rightFuncName, { password: this.pin });
					this.onlyClose();
				}
			}
		},
		clickDelete() {
			if (this.pin.length <= 0) {
				return;
			}

			this.failFlag = false;
			this.pin = this.pin.slice(0, this.pin.length - 1);
		}
	}
};
</script>

<style scoped>
.dim-popup-content {
	width: 500px;
}
.circle {
	position: relative;
	display: flex;
	gap: 40px;
	justify-content: center;
	align-items: center;
	height: 120px;
	margin-top: 20px;
}
.circle input[type='checkbox'] {
	appearance: none;
	position: inherit;
	width: 25px;
	height: 25px;
	clip: inherit;
	border: 1px solid #000;
	border-radius: 50px;
}
.circle input[type='checkbox']:checked {
	background-color: #000;
}
.circle span {
	position: absolute;
	bottom: 5px;
	color: #ff655a;
	font-size: 1.6rem;
}

.number {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
}
.number button {
	display: flex;
	justify-content: center;
	width: 33.33%;
	padding: 20px 0;
	font-size: 4rem;
	font-family: 'NotoLight';
	background-color: transparent;
}
.number button img {
	width: 70px;
}
</style>
